import {
  Alert,
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import { DatePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import moment from 'moment';
import { Fragment, useEffect, useRef, useState } from 'react';
import request from '../../utils/request';
import SnackbarAlert from '../common/SnackbarAlert';
import loader from '../common/loader.gif';

const EndorsementListView = () => {
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const [isLoading, setLoading] = useState(false);
  const [decodedArray, setDecodedArray] = useState([]);
  const [viewFlag, setViewFlag] = useState(false);
  const [decision, setDecision] = useState(true);
  const [showOtpAlert, setOtpAlert] = useState(false);
  const [otpFromTextbox, setOtpFromTextbox] = useState(null);
  const [sendLoader, setSendLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [otpSentMessage, setOtpSentMessage] = useState(null);
  const [showTimeRemaining, setShowTimeRemaining] = useState(false);
  const [seconds, setSeconds] = useState(null);
  const [status, setStatus] = useState(false);
  const [endorsementDetail, setEndorsementDetail] = useState(null);
  const [save, setSave] = useState<boolean>(true);
  const [walletStatusLoading, setWalletStatusLoading] = useState<boolean>(false);
  useEffect(() => {
    if (showTimeRemaining) {
      if (seconds > 0) {
        setTimeout(() => setSeconds(seconds - 1), 1000);
      } else {
        setOtpFromTextbox(null);
        setShowTimeRemaining(false);
      }
      setStatus(!status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTimeRemaining, seconds]);

  useEffect(() => {
    if (decodedArray['endorsementIds']) {
      getEndorsement();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decodedArray['endorsementIds']]);

  const secondsToMinutes = (e) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const h = Math.floor(e / 3600)
      .toString()
      .padStart(2, '0'),
      m = Math.floor((e % 3600) / 60)
        .toString()
        .padStart(2, '0'),
      s = Math.floor(e % 60)
        .toString()
        .padStart(2, '0');

    return 'Your OTP will expire in : ' + m + ':' + s;
  };

  useEffect(() => {
    if (endorsementDetail?.paymentType === 'WALLET') {
      checkWalletAmount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const checkWalletAmount = () => {
    setWalletStatusLoading(true);
    request({
      url: `endorsement/checkWalletStatus`,
      method: 'post',
      data: {
        endorsementId: endorsementDetail?.id,
        // amount: endorsementDetail?.premium
      }
    }).then(
      (response: any) => {
        if (response.status === true) {
          // setShowSnackBarAlert({
          //   status: true,
          //   type: 'success',
          //   message: response?.message
          // });
          setSave(true);
        } else {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: response?.message ? response?.message : 'Something went wrong'
          });
          setSave(false);
          setWalletStatusLoading(false);
        }
      },
      (error) => {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: error.message
        });
        setSave(false);
        setWalletStatusLoading(false);
      }
    );
  };
  const getEndorsement = () => {
    setLoading(true);
    request({
      url: `endorsement/getEndorsementById/${decodedArray['endorsementIds']}`,
      method: 'get'
    })
      .then((response: any) => {
        setLoading(false);
        setEndorsementDetail(response.data);
        formik.setValues((prev) => ({
          ...prev,
          bankName: response.data.bankAccountDetails?.bankName ?? null,
          accountNumber:
            response.data.bankAccountDetails?.accountNumber ?? null,
          ifscCode: response.data.bankAccountDetails?.ifscCode ?? null,
          city: response.data.bankAccountDetails?.city ?? null
        }));
      })
      .catch(function (err) {
        setLoading(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
  };

  useEffect(() => {
    // const isContentLoaded = document.readyState === 'complete';

    if (performance.getEntriesByType('navigation')[0]['type'] === 'reload') {
      // Remove the last hash fragment from the URL
      const urlWithoutLastHash = window.location.href.replace(/#[^#]*$/, '');

      // Navigate to the modified URL
      // window.location.replace(urlWithoutLastHash);
      let urlArray = urlWithoutLastHash.split('/');
      let encodedString = urlArray[4];

      const decoded = atob(encodedString);
      setDecodedArray(JSON.parse(decoded));
    } else {
      let urlArray = window.location.href.split('/');
      let encodedString = urlArray[4];

      const decoded = atob(encodedString);
      setDecodedArray(JSON.parse(decoded));
    }

    setOtpAlert(true);
    //customerLoginOtp();
  }, []);

  const customerLoginOtp = (type) => {
    setSendLoader(true);
    setOtpSentMessage(null);
    request({
      url: 'otp/customerOtpLogin',
      method: 'post',
      data: {
        customerType: decodedArray['customerType'],
        customerId: decodedArray['customerId'],
        corporateCustomerBranchMailId:
          decodedArray?.['corporateCustomerBranchMailId'] ?? null
      }
    })
      // eslint-disable-next-line
      .then((data) => {
        setSendLoader(false);
        setSeconds(60);
        setShowTimeRemaining(true);
        setOtpSentMessage(data['message']);
      })
      .catch(function (err) {
        setSendLoader(true);
        setLoading(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
  };

  const verifyOtp = () => {
    if (otpFromTextbox === null) {
      setShowSnackBarAlert({
        status: true,
        type: 'error',
        message: 'Please enter the OTP'
      });
      return;
    }
    setSubmitLoader(true);
    request({
      url: 'otp/verifyOtp',
      method: 'post',
      data: {
        userType: decodedArray['customerType'],
        userId: decodedArray['customerId'],
        otp: otpFromTextbox
      }
    })
      // eslint-disable-next-line
      .then((data: any) => {
        if (data.status) {
          // setLoader(false);
          setViewFlag(true);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: data['message']
          });
          getEndorsement();
          setOtpAlert(false);
        } else {
          // setLoader(false);
          setSubmitLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: data['message']
          });
          if (data?.message === 'OTP Expired') {
            setOtpFromTextbox(null);
          }
        }

        // getInsuranceComapany();
      })
      .catch(function (err) {
        // setLoader(false);
        setSubmitLoader(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
        if (err?.message === 'OTP Expired') {
          setOtpFromTextbox(null);
        }
      });
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const componentRef = useRef();

  const transactionSchema = Yup.object().shape({
    date: Yup.date().required('Date is required').typeError('Date is required'),
    // bank: Yup.string().required('Bank is required for refund').nullable(),
    // bankBranch: Yup.string()
    //   .required('Bank Branch is required for refund')
    //   .nullable(),
    referenceNumber: Yup.string()
      .required('Reference Number is required for refund')
      .nullable()
  });

  const handleApprovalSubmit = (values?: any) => {
    request({
      url: `endorsement/customerApproval`,
      method: 'post',
      data: {
        id: decodedArray['endorsementIds'],
        paymentType: endorsementDetail?.paymentType,
        paymentDetails: values
          ? {
            date: values.date,
            referenceNumber: values.referenceNumber,
            bankName: values.bankName,
            accountNumber: values.accountNumber,
            ifscCode: values.ifscCode,
            city: values.city,
            bankBranch: values.bankBranch
          }
          : null
      }
    })
      .then((response: any) => {
        setShowSnackBarAlert({
          status: true,
          type: 'success',
          message: response.message
        });
        setDecision(false);
      })
      .catch(function (err) {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      bankName: null,
      accountNumber: null,
      ifscCode: null,
      city: null,
      date: null,
      bankBranch: null,
      referenceNumber: ''
    },
    validationSchema: transactionSchema,
    onSubmit: async (values) => {
      handleApprovalSubmit(values);
    }
  });

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      {viewFlag ? (
        <Container>
          <Grid item xs={12} style={{ minHeight: '10.5vh' }}>
            <AppBar>
              <Toolbar style={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="h6"
                  component="div"
                  className="conformHead"
                >
                  Approve Endorsement
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>

          {isLoading ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <img
                        alt="loader"
                        src={loader}
                        className="loader"
                        width={100}
                        height={100}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          ) : (
            <>
              <div ref={componentRef}>
                <Paper
                  sx={{ mt: 2, p: 3, backgroundColor: '#fff' }}
                  elevation={3}
                >
                  <TableContainer component={Paper} sx={{ mt: 2 }}>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#d6eadf' }}>
                          <TableCell>
                            <strong>Item</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Sum Insured</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Premium</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Tax</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Total premium</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Effective date</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>Initial Sum Insured</TableCell>
                          <TableCell>
                            ₹ {endorsementDetail?.insurancePolicy?.sumInsured}
                          </TableCell>
                          <TableCell>
                            ₹ {endorsementDetail?.insurancePolicy?.totalPremium}
                          </TableCell>
                          <TableCell>
                            ₹ {endorsementDetail?.insurancePolicy?.gstAmount}
                          </TableCell>
                          <TableCell>
                            ₹{' '}
                            {Number(
                              endorsementDetail?.insurancePolicy
                                ?.totalPremium || 0
                            ) +
                              Number(
                                endorsementDetail?.insurancePolicy?.gstAmount ||
                                0
                              )}
                          </TableCell>
                          <TableCell>
                            {endorsementDetail?.insurancePolicy?.policyStartDate
                              ? moment(
                                endorsementDetail?.insurancePolicy
                                  ?.policyStartDate
                              ).format('DD-MM-YYYY')
                              : ''}
                          </TableCell>
                        </TableRow>

                        {/* Previous endorsements */}
                        {endorsementDetail?.previousEndorsements?.map(
                          (data, idx) => (
                            <TableRow key={idx}>
                              <TableCell>Endorsed Sum Insured</TableCell>
                              <TableCell>₹ {data?.sumInsured}</TableCell>
                              <TableCell>₹ {data?.premium}</TableCell>
                              <TableCell>₹ {data?.tax}</TableCell>
                              <TableCell>
                                ₹{' '}
                                {Number(data?.premium || 0) +
                                  Number(data?.tax || 0)}
                              </TableCell>
                              <TableCell>
                                {data?.endorsementEffectiveDate
                                  ? moment(
                                    data?.endorsementEffectiveDate
                                  ).format('DD-MM-YYYY')
                                  : ''}
                              </TableCell>
                            </TableRow>
                          )
                        )}

                        {/* Highlighted current endorsement */}
                        <TableRow sx={{ backgroundColor: '#fce4ec' }}>
                          <TableCell>
                            <strong>Endorsed Sum Insured</strong>
                          </TableCell>
                          <TableCell>
                            ₹ {endorsementDetail?.sumInsured}
                          </TableCell>
                          <TableCell>₹ {endorsementDetail?.premium}</TableCell>
                          <TableCell>₹ {endorsementDetail?.tax}</TableCell>
                          <TableCell>
                            ₹{' '}
                            {Number(endorsementDetail?.premium || 0) +
                              Number(endorsementDetail?.tax || 0)}
                          </TableCell>
                          <TableCell>
                            {endorsementDetail?.endorsementEffectiveDate
                              ? moment(
                                endorsementDetail?.endorsementEffectiveDate
                              ).format('DD-MM-YYYY')
                              : ''}
                          </TableCell>
                        </TableRow>

                        {/* Total row */}
                        <TableRow sx={{ backgroundColor: '#e0e0e0' }}>
                          <TableCell>
                            <strong>Total</strong>
                          </TableCell>
                          <TableCell>
                            ₹{' '}
                            {/* {Number(
                              endorsementDetail?.insurancePolicy?.sumInsured ||
                              0
                            ) +
                              endorsementDetail?.previousEndorsements?.reduce(
                                (acc, item) =>
                                  acc + Number(item?.sumInsured || 0),
                                0
                              ) +
                              Number(endorsementDetail?.sumInsured || 0)} */}
                            {endorsementDetail?.sumInsured}
                          </TableCell>
                          <TableCell>
                            ₹{' '}
                            {Number(
                              endorsementDetail?.insurancePolicy
                                ?.totalPremium || 0
                            ) +
                              endorsementDetail?.previousEndorsements?.reduce(
                                (acc, item) => acc + Number(item?.premium || 0),
                                0
                              ) +
                              Number(endorsementDetail?.premium || 0)}
                          </TableCell>
                          <TableCell>
                            ₹{' '}
                            {Number(
                              endorsementDetail?.insurancePolicy?.gstAmount || 0
                            ) +
                              endorsementDetail?.previousEndorsements?.reduce(
                                (acc, item) => acc + Number(item?.tax || 0),
                                0
                              ) +
                              Number(endorsementDetail?.tax || 0)}
                          </TableCell>
                          <TableCell>
                            ₹{' '}
                            {Number(
                              endorsementDetail?.insurancePolicy
                                ?.totalPremium || 0
                            ) +
                              Number(
                                endorsementDetail?.insurancePolicy?.gstAmount ||
                                0
                              ) +
                              endorsementDetail?.previousEndorsements?.reduce(
                                (acc, item) =>
                                  acc +
                                  Number(item?.premium || 0) +
                                  Number(item?.tax || 0),
                                0
                              ) +
                              Number(endorsementDetail?.premium || 0) +
                              Number(endorsementDetail?.tax || 0)}
                          </TableCell>
                          <TableCell />
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* {endorsementDetail?.paymentType === 'BANK' ? (
                    <>
                      <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
                        Account Details
                      </Typography>
                      <TableContainer component={Paper} sx={{ mt: 4 }}>
                        <Table>
                          <TableHead sx={{ backgroundColor: '#d6eadf' }}>
                            <TableRow>
                              <TableCell>
                                <strong>Bank Name</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Account Number</strong>
                              </TableCell>
                              <TableCell>
                                <strong>IFSC Code</strong>
                              </TableCell>
                              <TableCell>
                                <strong>City</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                {endorsementDetail?.bankAccountDetails
                                  ?.bankName || '-'}
                              </TableCell>
                              <TableCell>
                                {endorsementDetail?.bankAccountDetails
                                  ?.accountNumber || '-'}
                              </TableCell>
                              <TableCell>
                                {endorsementDetail?.bankAccountDetails
                                  ?.ifscCode || '-'}
                              </TableCell>
                              <TableCell>
                                {endorsementDetail?.bankAccountDetails?.city ||
                                  '-'}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null} */}
                  {endorsementDetail?.bankAccountDetails ? (
                    <Card sx={{ marginTop: '2vh' }}>
                      <CardContent>
                        <form onSubmit={formik.handleSubmit}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="stretch"
                            spacing={3}
                          >

                            <Grid item xs={12} md={4}>

                              <Typography color="textSecondary">
                                Account Number
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.accountNumber || "N/A"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <Typography color="textSecondary">
                                Bank Name
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.bankName || "-"}
                              </Typography>
                            </Grid>

                            {/* <Grid item xs={12} md={4}>
                                                          <Typography variant="caption" color="textSecondary">
                                                            Bank Branch
                                                          </Typography>
                                                          <Typography variant="body2">
                                                            {formik.values.bankBranch || "-"}
                                                          </Typography>
                                                        </Grid> */}

                            <Grid item xs={12} md={4}>
                              <Typography color="textSecondary">
                                IFSC Code
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.ifscCode || "-"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <Typography color="textSecondary">
                                City
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.city || "-"}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                                size="small"
                              >
                                <DatePicker
                                  views={['year', 'month', 'day']}
                                  inputFormat="dd-MM-yyyy"
                                  label={
                                    <Fragment>
                                      Date{' '}
                                      <Typography
                                        component="span"
                                        sx={{ color: 'red' }}
                                      >
                                        *
                                      </Typography>
                                    </Fragment>
                                  }
                                  value={formik.values.date}
                                  onChange={(newValue) => {
                                    formik.setFieldValue('date', newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      fullWidth
                                      name="date"
                                      size="small"
                                      {...params}
                                      error={
                                        formik.touched.date &&
                                        Boolean(formik.errors.date)
                                      }
                                      helperText={
                                        formik.touched.date &&
                                        formik.errors.date
                                      }
                                    />
                                  )}
                                  maxDate={new Date()}
                                />
                              </LocalizationProvider>
                            </Grid>


                            <Grid item xs={12} md={4}>
                              <TextField
                                label={
                                  <Fragment>
                                    Reference Number{' '}
                                    <Typography
                                      component="span"
                                      sx={{ color: 'red' }}
                                    >
                                      *
                                    </Typography>
                                  </Fragment>
                                }
                                sx={{ width: '100%' }}
                                size="small"
                                name="referenceNumber"
                                value={formik.values.referenceNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.referenceNumber &&
                                  Boolean(formik.errors.referenceNumber)
                                }
                                helperText={
                                  formik.touched.referenceNumber &&
                                  formik.errors.referenceNumber
                                }
                              />
                            </Grid>
                          </Grid>
                        </form>
                      </CardContent>
                    </Card>
                  ) : null}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '2vh'
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (
                          // endorsementDetail?.paymentType === 'BANK' &&
                          endorsementDetail?.bankAccountDetails
                        ) {
                          formik.handleSubmit();
                        } else {
                          handleApprovalSubmit();
                          setDecision(false);
                        }
                      }}
                      disabled={!decision || !save}
                    >
                      Approve
                    </Button>
                  </Box>
                </Paper>
              </div>
            </>
          )}
        </Container>
      ) : (
        <Dialog
          open={showOtpAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">OTP Verification</DialogTitle>
          <DialogContent>
            <Container maxWidth="sm">
              <FormControl variant="outlined" fullWidth>
                <TextField
                  type="text"
                  placeholder="Enter Your OTP Here..."
                  value={otpFromTextbox || ''}
                  onChange={(e) => {
                    setOtpFromTextbox(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <LoadingButton
                          loading={submitLoader || sendLoader}
                          variant="contained"
                          type="button"
                          onClick={() => {
                            if (showOtpAlert === true && !showTimeRemaining) {
                              customerLoginOtp('generate');
                            } else {
                              verifyOtp();
                            }
                          }}
                          disabled={
                            (!decodedArray['customerType']) || (
                              seconds > 0 &&
                              seconds <= 60 &&
                              !otpFromTextbox?.length
                            )
                          }
                        >
                          {showOtpAlert === true && seconds === null
                            ? 'Send OTP'
                            : seconds === 0
                              ? 'Resend OTP'
                              : 'Verify OTP'}
                        </LoadingButton>
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>
              {/* {JSON.stringify(decodedArray)} */}
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                  {showTimeRemaining ? <>{secondsToMinutes(seconds)}</> : null}
                </Grid>
                <Grid item xs={12}>
                  {otpSentMessage ? (
                    <Alert severity="success">{otpSentMessage}</Alert>
                  ) : null}
                </Grid>
              </Grid>
            </Container>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
export default EndorsementListView;
